export const API_URL = import.meta.env.VITE_API_URL;
export const RECAPTCHA_SITE_KEY = import.meta.env.VITE_APP_RECAPTCHA_SITE_KEY;

// # Google Authentication Popup
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
export const GOOGLE_REDIRECT_URI = import.meta.env.VITE_GOOGLE_REDIRECT_URI_QA;
export const GOOGLE_SCOPES = import.meta.env.VITE_GOOGLE_SCOPES;

// # Microsoft Authentication Popup
export const MICROSOFT_CLIENT_ID = import.meta.env.VITE_MICROSOFT_CLIENT_ID;
export const MICROSOFT_SCOPES = import.meta.env.VITE_MICROSOFT_SCOPES;
export const MICROSOFT_TENANT_ID = import.meta.env.VITE_MICROSOFT_TENANT_ID;
export const MICROSOFT_REDIRECT_URl = import.meta.env.VITE_MICROSOFT_REDIRECT_URl_QA;

// # sip connect for the pbx
export const SIP_SERVER_URL = import.meta.env.VITE_SIP_SERVER_URL_QA;
export const SIP_CALL_DOMAIN = import.meta.env.VITE_SIP_CALL_DOMAIN_QA;

// #  Whatsapp Authentication Popup
export const WHATSAPP_APP_ID = import.meta.env.VITE_WHATSAPP_APP_ID_QA;
export const WHATSAPP_CONFIG_ID = import.meta.env.VITE_WHATSAPP_CONFIG_ID_QA;
export const MOYASAR_PUBLIC_KEY = import.meta.env.VITE_MOYASAR_PUBLIC_KEY_QA;
